module.exports = __webpack_public_path__ + "img/example-thai-id.157dd192.jpg";